module.exports = __webpack_public_path__ + "static/img/image_solutions_ime_02.655ed7b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_ime_02.png
// module id = DgMN
// module chunks = 10